import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {
  GetUser,
  GetCompany,
  GetProduct,
  GetPolicyType,
  GetSubProduct,
  GetBookingCode,
  GetSubBookingCode,
  GetFuelType,
  GetUserpayablePercentage,
  GetBranchpayablePercentage,
  GetReceivablePayablePercentage,
  GetPolicyFileById,
  ReadPolicyFileByPolicyId,
  GetVehicleMake,
  LoginPortalData,
  GetLinkBookingCode,
  retreiveDataFromPolicy,
  getPolicyBazaarTicketNumber,
  GetBulkUploadExcelFileById,
  downloadFileByKey,
  GetAddOn,
} from "../../../Service/_index";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment/moment";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionSharpIcon from "@mui/icons-material/DescriptionSharp";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DatePicker, Space } from "antd";
import { Formik, Form, Field } from "formik";
import { UpdatePolicyList } from "../../../Service/_index";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import { ID_CONFIG, PolicyFilterTypes } from "../../../Shared/CommonConstant";
import { CalculateIcon } from "../../../Resources/Icons/icons";
import Loader from "../../../UiComponents/Loader/Loader";
import { GetRTOList } from "../../../Service/RTOService";
import Styles from "../../../UiComponents/Scss/CommonDrawer.module.scss";
import CancelPolicyDialog from "../CancelPolicyDialog/CancelPolicyDialog";
import { Divider, Stack } from "@mui/material";
import { RemoveRedEyeIcon } from "../../../Resources/Icons/icons";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const PaymentDetails = [
  {
    label: "Cash",
    value: 1,
  },
  {
    label: "Online",
    value: 2,
  },
  {
    label: "Cheque",
    value: 3,
  },
  {
    label: "DD",
    value: 4,
  },
];

const OdPolicyPeriodController = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
];

const validationSchema = Yup.object().shape({
  bookingCodeId: Yup.string().required("Bookingcode Required"),
  subBookingCodeId: Yup.string().required("Sub Bookingcode Required"),
  policyTypeId: Yup.string().required("Policytype Required"),
  productId: Yup.string().required("Product Required"),
  companyId: Yup.string().required("Company Required"),
  subProductId: Yup.string().required("Sub Product Required"),
  customerName: Yup.string().required("CustomerName Required"),
  mobileNumber: Yup.string().required("Mobile Number Required"),
  email: Yup.string().required("Email Required"),
  registrationNumber: Yup.string().required("Reg Number Required"),
  make: Yup.string().required("Make  Required"),
  model: Yup.string().required("Model Required"),
  cc: Yup.string().required("CC Required"),
  gvw: Yup.string().required("GVW Required"),
  seatingCapacity: Yup.string().required("Seating Capacity Required"),
  registrationYear: Yup.string().required("Registeration Year Required"),
  fuelType: Yup.string().required("Fuel type Required"),
  addOnId: Yup.array().min(1, "At least one Add-on is required").required("Add-on Required"),
  odPolicyStartDate: Yup.string().required("OD Policy Startdate Required"),
  odPolicyPeriod: Yup.string().required("OD Policy Period Required"),
  odDisc: Yup.string().required("OD Disc Required"),
  odPremium: Yup.string().required("OD Premium Required"),
  tpPremium: Yup.string().required("TP Premium Required"),
  netPremium: Yup.string().required("Net Premium Required"),
  totalPremium: Yup.string().required("Total Premium Required"),
  paCover: Yup.string().required("PA Cover Required"),
});

const TodayDate = new Date();

const initialValues = {
  userId: "",
  loginIdFull: "",
  companyId: "",
  productId: "",
  subProductId: "",
  policyTypeId: "",
  bookingCodeId: "",
  subBookingCodeId: "",
  policyNumber: "",
  customerName: "",
  mobileNumber: "",
  email: "",
  registrationNumber: "",
  make: "",
  model: "",
  seatingCapacity: "",
  cc: "",
  gvw: "",
  registrationYear: "",
  odDisc: "",
  odPremium: "",
  tpPremium: "",
  netPremium: "",
  totalPremium: "",
  paCover: "",
  paymentMode: "",
  fuelType: "",
  odPolicyStartDate: new Date(),
  odPolicyPeriod: "",
  odPolicyEndDate: new Date(),
  tpPolicyStartDate: new Date(),
  tpPolicyPeriod: "",
  tpPolicyEndDate: new Date(),
  issueDate: new Date(),
  chequeDate: new Date(),
  bankName: "",
  chequeNumber: "",
  checkedNumber: "", //it is a entry pending checking number
  rejectedReason: "",
  userOdPercentage: "",
  userTpPercentage: "",
  userNetPercentage: "",
  userOdAmount: "",
  userTpAmount: "",
  userNetAmount: "",
  userTotalPayable: "",
  branchOdPercentage: "",
  branchTpPercentage: "",
  branchNetPercentage: "",
  branchOdAmount: "",
  branchTpAmount: "",
  branchNetAmount: "",
  branchTotalPayabl: "",
  receivableOdPercentage: "",
  receivableTpPercentage: "",
  receivableNetPercentage: "",
  receivableOdAmount: "",
  receivableTpAmount: "",
  receivableNetAmount: "",
  receivableTotalPayabl: "",
  rtoId: "", //Changes by Arun
  addOnId: [],
};

const EditPolicyList = (props) => {
  const formRef = useRef(null);
  const [openCancelPolicyDialog, setOpenCancelPolicyDialog] = useState(false);
  const {
    setOpenEditPolicyDrawer,
    selectedData,
    formType,
    GetData,
    editType,
    openEditPolictDrawer,
  } = props;
  const [userDetails, setUserDetails] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [subProductDetails, setSubProductDetails] = useState([]);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [policyTypeDetails, setPolicyTypeDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [fuelType, setFuelType] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [showPaymentMethod, setShowPaymentMethod] = useState(
    selectedData?.paymentMode === "cheque" ? 3 : null
  );

  const navigate = useNavigate();
  const [disableOne, setDisableOne] = useState(true);

  const [userValue, setUserValue] = useState(
    formType === "edit" ? selectedData?.userId?.name : null
  );
  const [companyValue, setCompanyValue] = useState(
    formType === "edit" ? selectedData?.companyId?.shortName : null
  );
  const [productValue, setProductValue] = useState(
    formType === "edit" ? selectedData?.productId?.product : null
  );
  const [subProductValue, setSubProductValue] = useState(
    formType === "edit" ? selectedData?.subProductId?.subProduct : null
  );
  const [policyTypeValue, setPolicyTypeValue] = useState(
    formType === "edit" ? selectedData?.policyTypeId?.policyType : null
  );
  const [bookingCodeValue, setBookingCodeValue] = useState(
    formType === "edit" ? selectedData?.bookingCodeId?.bookingCode : null
  );
  const [fuelTypeValue, setFuelTypeValue] = useState(
    formType === "edit" ? selectedData?.fuelType?.fuelType : null
  );
  const [subBookingCodeValue, setSubBookingCodeValue] = useState(
    formType === "edit" ? selectedData?.subBookingCodeId?.subBookingCode : null
  );

  const [odPolicyEndDateValue, setOdPolicyEndDateValue] = React.useState(
    formType === "edit" ? dayjs(selectedData?.odPolicyEndDate) : null
  );
  const [tpPolicyDate, settpPolicyDate] = React.useState(
    formType === "edit" ? dayjs(selectedData?.tpPolicyEndDate) : null
  );


  const [editableData, setEditableData] = useState(
    selectedData.status === PolicyFilterTypes[2].value && editType === "VerifyPendingButton" ? true : false
  );
  const [value, setValue] = React.useState(1);
  const [showPolUpTable, setShowPolUpTable] = useState(false);
  const [showRejectField, setShowRejectField] = useState(false);
  const [approveKey, setApproveKey] = useState(null);
  const [openViewCal, setOpenViewCal] = useState(false);
  const [fillIssueDate, setFillIssueDate] = useState(
    dayjs(selectedData?.issueDate)
  );
  const [selectedCompany, setSelectedCompany] = useState(companyValue);
  const [rtoList, setRTOList] = useState([]); // Changes by Arun
  const [rtoListDropdown, setRTOListDropdown] = useState([]); // Changes by Arun
  const [rtoValue, setRtoValue] = useState(null); // Changes by Arun
  const [rtoIdValue, setRtoIdValue] = useState(null); // Changes by Arun
  const [addOnDetails, setAddOnDetails] = useState([]);
  const [selectedAddOns, setSelectedAddOns] = useState(
    formType === "edit" && selectedData?.addOnId ? selectedData.addOnId : []
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangePerTap = (e, newValue) => {
    setValue(Number(newValue) + 1);
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData).then((res) => {
      const modifiedUserDetails = res?.data
        ?.map((e) => {
          if (e.userType.includes("user") && e.isEnabled === true) {
            return {
              ...e,
              label: e?.name + " - " + e?.mobileNumber + " - " + e?.email,
              value: e._id,
            };
          }
        })
        .filter(Boolean);
      setUserDetails(modifiedUserDetails);
    });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  const GetPolicyDetails = () => {
    GetPolicyType({ isAscending: true }).then((res) => {
      const modifiedPolicyTypeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.policyType,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setPolicyTypeDetails(modifiedPolicyTypeDetails);
    });
  };

  const GetLinkBookingCodeDetails = () => {
    GetLinkBookingCode().then((res) => {
      const modifiedBookingCodeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCodeId.bookingCode,
              value: e.bookingCodeId._id,
            };
          }
        })
        .filter(Boolean);
      const modData = modifiedBookingCodeDetails.filter(
        (e) => e?.companyId?._id === selectedCompanyId
      );
      let uniqueObjectsMap = new Map();
      modData.map((obj) => {
        uniqueObjectsMap.set(obj.bookingCodeId._id, obj);
      });
      let uniqueArray = Array.from(uniqueObjectsMap.values());
      setBookingCodeDetails(uniqueArray);
    });
  };

  const GetAddOnDetails = () => {
    GetAddOn({ isAscending: true }).then((res) => {
      const modifiedAddOnDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.addOn,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setAddOnDetails(modifiedAddOnDetails);
    });
  };

  useEffect(() => {
    // Changes by Arun
    const getRtoList = async () => {
      await GetRTOList().then((res) => {
        setRTOList(res?.data || []);
        if (selectedData.rtoId) {
          const findDoc = res.data.find((element) => {
            if (element._id == selectedData.rtoId) return element;
          });
          setRtoValue(findDoc?.label);
          setRtoIdValue(findDoc._id);
        }
        checkRTO(res?.data, selectedData?.registrationNumber); //Changes by Arun
      });
    };

    GetLinkBookingCodeDetails();
    getRtoList(); //Changes by Arun
    GetAddOnDetails();
  }, []);

  // Sync selectedAddOns when selectedData changes or when editing
  useEffect(() => {
    if (formType === "edit" && selectedData?.addOnId && Array.isArray(selectedData.addOnId)) {
      // Check if addOnId contains objects or just IDs
      const addOnIds = selectedData.addOnId.map((item) =>
        typeof item === 'object' && item._id ? item._id : item
      );
      setSelectedAddOns(addOnIds);
    }
  }, [formType, selectedData]);

  // const GetBookingCodeDetails = () => {
  //   GetBookingCode({ isAscending: true }).then((res) => {
  //     const modifiedBookingCodeDetails = res.data
  //       .map((e) => {
  //         if (e.isEnabled) {
  //           return {
  //             ...e,
  //             label: e.bookingCode,
  //             value: e._id,
  //           };
  //         } else {
  //           return null;
  //         }
  //       })
  //       .filter(Boolean);
  //     setBookingCodeDetails(modifiedBookingCodeDetails);
  //   });
  // };

  const GetFuelTypeDetails = () => {
    GetFuelType().then((res) => {
      const modifiedFuelTypeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.fuelType,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setFuelType(modifiedFuelTypeDetails);
    });
  };

  const GetProductDetails = () => {
    GetProduct({ isAscending: true }).then((res) => {
      const modifiedProductDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.product,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setProductDetails(modifiedProductDetails);
    });
  };

  const [productIdValue, setProductIdValue] = useState(
    formType === "edit" ? selectedData?.productId?._id : null
  );
  const [subProductIdValue, setSubProductIdValue] = useState(
    formType === "edit" ? selectedData?.subProductId?._id : null
  );
  const [vehicleMakeDetails, setVehicleMakeDetails] = useState([]);
  const [vehicleValue, setVehicleValue] = useState(
    formType === "edit" ? selectedData?.make?.vehicleMake : null
  );

  const GetSubProductDetails = () => {
    GetSubProduct({ isAscending: true }).then((res) => {
      const modifiedSubProductDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subProduct,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      const FilterSubProductDetails = modifiedSubProductDetails.filter(
        (item) => item?.productID === productIdValue
      );
      setSubProductDetails(FilterSubProductDetails);
    });
  };

  // Changes by Arun
  const checkRTO = (tempRtoList, registrationNumber) => {
    // console.log("registrationNumber ", registrationNumber);
    if (!registrationNumber) {
      return true;
    }
    const regNumber = registrationNumber.replace("-", "");
    const firstFourChar = regNumber.substring(0, 4);
    // console.log("firstFourChar ", firstFourChar);
    // console.log("tempRtoList ", tempRtoList);
    const findDoc = tempRtoList.find((element) => {
      if (element.label == firstFourChar.toUpperCase()) return element;
    });
    if (findDoc) {
      setRTOListDropdown([findDoc]);
      if (formType === "edit") {
        formRef.current?.setFieldValue("rtoId", findDoc._id);
      }
      setRtoValue(findDoc?.label);
      setRtoIdValue(findDoc._id);
    } else {
      setRTOListDropdown(tempRtoList);
    }
  };
  //vehicleMake added by gokul..

  const GetVehicleMakeDetails = () => {
    GetVehicleMake({ isAscending: true }).then((res) => {
      const modifiedVehicleMakeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.vehicleMake,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      const data = modifiedVehicleMakeDetails.filter((n) => {
        if (n.productID === productIdValue) {
          return n;
        }
      });
      setVehicleMakeDetails(data);
    });
  };

  // loginPortal added by gokul...

  const [selectedUserId, setSelectedUserId] = useState(
    formType === "edit" ? selectedData?.userId?._id : null
  );
  const [selectedCompanyId, setSelectedCompanyId] = useState(
    formType === "edit" ? selectedData?.companyId?._id : null
  );
  const [selectedLoginPortal, setSelectedLoginPortal] = useState(
    formType === "edit" ? selectedData?.loginIdFull : null
  );
  const [loginPortalDetails, setLoginPortalDetails] = useState([]);

  const GetLoginPortalData = () => {
    LoginPortalData({
      userId: selectedUserId,
      companyId: selectedCompanyId,
      isActive: true,
    }).then((res) => {
      const filterData1 = res?.data.filter((item) => {
        if (item?.userId === selectedUserId) {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });
      const UserAllData = res?.data.filter((item) => {
        if (item?.userId === "All") {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });

      const UserAdminData = res?.data.filter((item) => {
        if (item?.userId === "Admin") {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });
      setLoginPortalDetails([...filterData1, ...UserAllData, ...UserAdminData]);
    });
  };

  useEffect(() => {
    if (selectedUserId) GetLoginPortalData();
    else setLoginPortalDetails([]);
  }, [selectedUserId, selectedCompanyId]);

  useEffect(() => {
    GetVehicleMakeDetails();
    GetSubProductDetails();
  }, [productIdValue]);

  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCodeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      const FilterSubBookingCodeDetails = modifiedSubBookingCodeDetails.filter(
        (item) => item.bookingCode === bookingCodeValue
      );
      setSubBookingCodeDetails(FilterSubBookingCodeDetails);
    });
  };

  useEffect(() => {
    GetSubBookingCodeDetails();
  }, [bookingCodeValue]);

  useEffect(() => {
    GetUserDetails();
    GetCompanyDetails();
    GetProductDetails();
    GetPolicyDetails();
    // GetBookingCodeDetails();
    GetFuelTypeDetails();
    if (formType === "edit") {
      formRef.current?.setFieldValue("userId", selectedData?.userId?._id);
      formRef.current?.setFieldValue("loginIdFull", selectedData?.loginIdFull);
      formRef.current?.setFieldValue("companyId", selectedData?.companyId?._id);
      formRef.current?.setFieldValue("productId", selectedData?.productId?._id);
      formRef.current?.setFieldValue(
        "policyTypeId",
        selectedData?.policyTypeId?._id
      );
      formRef.current?.setFieldValue(
        "bookingCodeId",
        selectedData?.bookingCodeId?._id
      );
      formRef.current?.setFieldValue(
        "subProductId",
        selectedData?.subProductId?._id
      );
      formRef.current?.setFieldValue(
        "subBookingCodeId",
        selectedData?.subBookingCodeId?._id
      );
      formRef.current?.setFieldValue("policyNumber", selectedData?.policyNumber);
      formRef.current?.setFieldValue(
        "customerName",
        selectedData?.customerName
      );
      formRef.current?.setFieldValue(
        "mobileNumber",
        selectedData?.mobileNumber
      );
      formRef.current?.setFieldValue("email", selectedData?.email);
      formRef.current?.setFieldValue("make", selectedData?.make?._id);
      formRef.current?.setFieldValue("model", selectedData?.model);
      formRef.current?.setFieldValue(
        "seatingCapacity",
        selectedData?.seatingCapacity
      );
      formRef.current?.setFieldValue("cc", selectedData?.cc);
      formRef.current?.setFieldValue("gvw", selectedData?.gvw);
      formRef.current?.setFieldValue(
        "registrationYear",
        selectedData?.registrationYear
      );
      formRef.current?.setFieldValue("odDisc", selectedData?.odDisc);
      formRef.current?.setFieldValue("odPremium", selectedData?.odPremium);
      formRef.current?.setFieldValue("tpPremium", selectedData?.tpPremium);
      formRef.current?.setFieldValue("netPremium", selectedData?.netPremium);
      formRef.current?.setFieldValue("fuelType", selectedData?.fuelType?._id);
      formRef.current?.setFieldValue(
        "totalPremium",
        selectedData?.totalPremium
      );
      formRef.current?.setFieldValue("paCover", selectedData?.paCover);
      formRef.current?.setFieldValue("paymentMode", selectedData?.paymentMode);
      formRef.current?.setFieldValue("issueDate", selectedData?.issueDate);
      formRef.current?.setFieldValue("chequeNumber", selectedData?.chequeNumber);
      formRef.current?.setFieldValue("bankName", selectedData?.bankName);
      formRef.current?.setFieldValue("chequeDate", selectedData?.chequeDate);
      formRef.current?.setFieldValue("status", selectedData?.status);
      formRef.current?.setFieldValue(
        "odPolicyStartDate",
        selectedData?.odPolicyStartDate
          ? selectedData?.odPolicyStartDate
          : dayjs(TodayDate)
      );
      formRef.current?.setFieldValue(
        "odPolicyEndDate",
        selectedData?.odPolicyEndDate
      );
      formRef.current?.setFieldValue(
        "odPolicyPeriod",
        selectedData?.odPolicyPeriod
      );
      formRef.current?.setFieldValue(
        "tpPolicyStartDate",
        selectedData?.tpPolicyStartDate
          ? selectedData?.tpPolicyStartDate
          : dayjs(TodayDate)
      );
      formRef.current?.setFieldValue(
        "tpPolicyEndDate",
        selectedData?.tpPolicyEndDate
      );
      formRef.current?.setFieldValue(
        "tpPolicyPeriod",
        selectedData?.tpPolicyPeriod
      );
      formRef.current?.setFieldValue(
        "registrationNumber",
        selectedData?.registrationNumber
      );
      formRef.current?.setFieldValue("rtoId", selectedData?.rtoId || ""); // Changes by Arun
      // Extract IDs from addOnId array (handles both objects and IDs)
      const addOnIds = selectedData?.addOnId
        ? selectedData.addOnId.map((item) => typeof item === 'object' && item._id ? item._id : item)
        : [];
      formRef.current?.setFieldValue("addOnId", addOnIds);
    }
  }, []);

  const PaymentFunction = (e) => {
    setShowPaymentMethod(e.value);
    formRef.current?.setFieldValue("paymentMode", e.label);
  };
  const UserName = sessionStorage.getItem("UserId");
  const userType = sessionStorage.getItem("userType");

  const CalaculteFunction = (e) => {
    const UserODAmountValue = (e?.odPremium * e.userOdPercentage) / 100;
    const UserTPAmountValue = (e?.tpPremium * e.userTpPercentage) / 100;
    const UserNETAmountValue = (e?.netPremium * e.userNetPercentage) / 100;
    const BranchODAmountValue = (e?.odPremium * e.branchOdPercentage) / 100;
    const BranchTPAmountValue = (e?.tpPremium * e.branchTpPercentage) / 100;
    const BranchNETAmountValue = (e?.netPremium * e.branchNetPercentage) / 100;
    const ReceivableODAmountValue =
      (e?.odPremium * e.receivableOdPercentage) / 100;
    const ReceivableTPAmountValue =
      (e?.tpPremium * e.receivableTpPercentage) / 100;
    const ReceivableNetAmountValue =
      (e?.netPremium * e.receivableNetPercentage) / 100;
    const UserTotalValue = (
      (UserODAmountValue ? UserODAmountValue : 0) +
      (UserTPAmountValue ? UserTPAmountValue : 0) +
      (UserNETAmountValue ? UserNETAmountValue : 0)
    ).toFixed(2);
    const BranchTotalValue = (
      (BranchODAmountValue ? BranchODAmountValue : 0) +
      (BranchTPAmountValue ? BranchTPAmountValue : 0) +
      (BranchNETAmountValue ? BranchNETAmountValue : 0)
    ).toFixed(2);
    const ReceivableTotalValue = (
      (ReceivableODAmountValue ? ReceivableODAmountValue : 0) +
      (ReceivableTPAmountValue ? ReceivableTPAmountValue : 0) +
      (ReceivableNetAmountValue ? ReceivableNetAmountValue : 0)
    ).toFixed(2);
    formRef.current?.setFieldValue(
      "userOdAmount",
      UserODAmountValue ? UserODAmountValue : 0
    );
    formRef.current?.setFieldValue(
      "userTpAmount",
      UserTPAmountValue ? UserTPAmountValue : 0
    );
    formRef.current?.setFieldValue(
      "userNetAmount",
      UserNETAmountValue ? UserNETAmountValue : 0
    );
    formRef.current?.setFieldValue(
      "branchOdAmount",
      BranchODAmountValue ? BranchODAmountValue : 0
    );
    formRef.current?.setFieldValue(
      "branchTpAmount",
      BranchTPAmountValue ? BranchTPAmountValue : 0
    );
    formRef.current?.setFieldValue(
      "branchNetAmount",
      BranchNETAmountValue ? BranchNETAmountValue : 0
    );
    formRef.current?.setFieldValue(
      "receivableOdAmount",
      ReceivableODAmountValue ? ReceivableODAmountValue : 0
    );
    formRef.current?.setFieldValue(
      "receivableTpAmount",
      ReceivableTPAmountValue ? ReceivableTPAmountValue : 0
    );
    formRef.current?.setFieldValue(
      "receivableNetAmount",
      ReceivableNetAmountValue ? ReceivableNetAmountValue : 0
    );
    formRef.current?.setFieldValue("userTotalPayable", UserTotalValue);
    formRef.current?.setFieldValue("branchTotalPayabl", BranchTotalValue);
    formRef.current?.setFieldValue("receivableTotalPayabl", ReceivableTotalValue);
  };
  console.log("editableData", editableData);
  const onSubmit = async (data) => {
    if (true) {
      const CurrentDate = new Date();
      data.policyNumber = data?.policyNumber; //?.replace(/[^a-zA-Z0-9/]/g, "");
      data.updatedBy = UserName;
      data.updatedAt = CurrentDate[
        ("totalPremium", "registrationNumber", "cc", "gvw")
      ]?.forEach((item) => (data[item] = data[item]?.replace(/-/g, "")));
      if (editType === "CommonEdit") {
        data.status = data.status;
        UpdatePolicyList(selectedData?._id, data).then((res) => {
          GetData();
          setOpenEditPolicyDrawer(false);
        });
      } else {
        if (data?.paymentMode === "Cheque" && approveKey) {
          data.status = PolicyFilterTypes[5].value;
          UpdatePolicyList(selectedData?._id, data).then((res) => {
            GetData();
            setOpenEditPolicyDrawer(false);
          });
        } else if (approveKey && !(data?.paymentMode === "Cheque")) {
          data.status = PolicyFilterTypes[2].value;
          data.verifyPendingBy = UserName;
          data.verifyPendingAt = CurrentDate;
          UpdatePolicyList(selectedData?._id, data).then((res) => {
            GetData();
            setOpenEditPolicyDrawer(false);
          });
        } else if (data?.status === PolicyFilterTypes[2].value) {
          try {
            data.UserODAmountValue =
              (data?.odPremium * data.userOdPercentage) / 100;
            data.UserTPAmountValue =
              (data?.tpPremium * data.userTpPercentage) / 100;
            data.UserNETAmountValue =
              (data?.netPremium * data.userNetPercentage) / 100;
            data.BranchODAmountValue =
              (data?.odPremium * data.branchOdPercentage) / 100;
            data.BranchTPAmountValue =
              (data?.tpPremium * data.branchTpPercentage) / 100;
            data.BranchNETAmountValue =
              (data?.netPremium * data.branchNetPercentage) / 100;
            data.ReceivableODAmountValue =
              (data?.odPremium * data.receivableOdPercentage) / 100;
            data.ReceivableTPAmountValue =
              (data?.tpPremium * data.receivableTpPercentage) / 100;
            data.ReceivableNetAmountValue =
              (data?.netPremium * data.receivableNetPercentage) / 100;
            data.UserTotalValue = (
              (data.UserODAmountValue ? data.UserODAmountValue : 0) +
              (data.UserTPAmountValue ? data.UserTPAmountValue : 0) +
              (data.UserNETAmountValue ? data.UserNETAmountValue : 0)
            ).toFixed(2);
            data.BranchTotalValue = (
              (data.BranchODAmountValue ? data.BranchODAmountValue : 0) +
              (data.BranchTPAmountValue ? data.BranchTPAmountValue : 0) +
              (data.BranchNETAmountValue ? data.BranchNETAmountValue : 0)
            ).toFixed(2);
            data.ReceivableTotalValue = (
              (data.ReceivableODAmountValue
                ? data.ReceivableODAmountValue
                : 0) +
              (data.ReceivableTPAmountValue
                ? data.ReceivableTPAmountValue
                : 0) +
              (data.ReceivableNetAmountValue
                ? data.ReceivableNetAmountValue
                : 0)
            ).toFixed(2);
          } finally {

            if (editableData) {
              // if (data.UserTotalValue > 0) {
              if (
                parseFloat(data.UserTotalValue) > 0 ||
                parseFloat(data.userTotalPayable) > 0
              ) {
                data.isUserPayable = true;
                data.status = PolicyFilterTypes[4].value;
                data.userPayable = {
                  ODPercentage: data?.userOdPercentage,
                  TPPercentage: data?.userTpPercentage,
                  NETPercentage: data?.userNetPercentage,
                  ODAmount: data.UserODAmountValue,
                  TPAmount: data.UserTPAmountValue,
                  NETAmount: data.UserNETAmountValue,
                  Total:
                    parseFloat(data.UserTotalValue) > 0
                      ? data.UserTotalValue
                      : data.userTotalPayable,
                  createdBy: UserName,
                  createdAt: CurrentDate,
                  updatedAt: CurrentDate,
                  updatedBy: UserName,
                };
              } else {
                data.status = PolicyFilterTypes[3].value;
                data.approvePendingBy = UserName;
                data.approvePendingAt = CurrentDate;
              }
              // Changes by Arun
              // if (data.BranchTotalValue > 0) {
              if (
                parseFloat(data.BranchTotalValue) > 0 ||
                parseFloat(data.branchTotalPayabl) > 0
              ) {
                data.isBranchPayable = true;
                data.branchPayable = {
                  ODPercentage: data?.branchOdPercentage,
                  TPPercentage: data?.branchTpPercentage,
                  NETPercentage: data?.branchNetPercentage,
                  ODAmount: data.BranchODAmountValue,
                  TPAmount: data.BranchTPAmountValue,
                  NETAmount: data.BranchNETAmountValue,
                  Total:
                    parseFloat(data.BranchTotalValue) > 0
                      ? data.BranchTotalValue
                      : data.branchTotalPayabl,
                  createdBy: UserName,
                  createdAt: CurrentDate,
                  updatedAt: CurrentDate,
                  updatedBy: UserName,
                };
              }

              // Changes by Arun
              // if (data.ReceivableTotalValue > 0) {
              if (
                parseFloat(data.ReceivableTotalValue) > 0 ||
                parseFloat(data.receivableTotalPayabl) > 0
              ) {
                data.isCommisionRecievable = true;
                data.commisionRecievable = {
                  ODPercentage: data?.receivableOdPercentage,
                  TPPercentage: data?.receivableTpPercentage,
                  NETPercentage: data?.receivableNetPercentage,
                  ODAmount: data?.ReceivableODAmountValue,
                  TPAmount: data?.ReceivableTPAmountValue,
                  NETAmount: data?.ReceivableNetAmountValue,
                  Total: parseFloat(data?.ReceivableTotalValue)
                    ? data?.ReceivableTotalValue
                    : data.receivableTotalPayabl,
                  createdBy: UserName,
                  createdAt: CurrentDate,
                  updatedAt: CurrentDate,
                  updatedBy: UserName,
                };
              }
              if (
                ID_CONFIG.BOOKING_CODE == data.bookingCodeId
                // &&
                // ID_CONFIG.SUBBOOKING_CODE == data.subBookingCodeId
              ) {
                try {
                  setOpenLoader(true);
                  const res = await getPolicyBazaarTicketNumber(
                    selectedData._id
                  );
                  data["ticketNumber"] = res.data.message;
                  data["ticketCreatedBy"] = UserName;
                } catch (error) {
                  console.log("cc entry error : ", error);
                } finally {
                  UpdatePolicyList(selectedData?._id, data).then((res) => {
                    GetData();
                    setOpenEditPolicyDrawer(false);
                  });
                  setOpenLoader(false);
                }
              } else {
                UpdatePolicyList(selectedData?._id, data).then((res) => {
                  GetData();
                  setOpenEditPolicyDrawer(false);
                });
              }
            } else {
              data.status = data.status;
              UpdatePolicyList(selectedData?._id, data).then((res) => {
                GetData();
                setOpenEditPolicyDrawer(true);
                data.status === PolicyFilterTypes[2].value
                  ? setEditableData(true)
                  : setEditableData(false);
              });
            }
          }
        } else {
          data.status = data?.status;
          UpdatePolicyList(selectedData?._id, data).then((res) => {
            GetData();
            setOpenEditPolicyDrawer(false);
          });
        }
      }

      // UpdatePolicyList(selectedData?._id, data).then((res) => {
      //   GetData();

      //   if (editableData) {
      //     setOpenEditPolicyDrawer(false);
      //   } else {
      //     if (res) {
      //       data.status === PolicyFilterTypes[2].value ? setEditableData(true) : setEditableData(false)
      //       data.status === (PolicyFilterTypes[2].value) ? setOpenEditPolicyDrawer(true) : setOpenEditPolicyDrawer(false);
      //       data.isCloseDrawer ? setOpenEditPolicyDrawer(false) : setOpenEditPolicyDrawer(true)
      //       editType === "CommonEdit" && setOpenEditPolicyDrawer(false);
      //     } else {
      //       setOpenEditPolicyDrawer(true);
      //     }
      //   }
      // });
    } else {
      ToastError("Enter All Fields");
    }
  };

  const GetPayablePercentFunction = () => {
    setOpenViewCal(!openViewCal);
    GetUserpayablePercentage(selectedData?._id).then((res) => {
      formRef.current?.setFieldValue("userOdPercentage", res?.data?.OD);
      formRef.current?.setFieldValue("userTpPercentage", res?.data?.TP);
      formRef.current?.setFieldValue("userNetPercentage", res?.data?.Net);
    });
    GetBranchpayablePercentage(selectedData?._id).then((res) => {
      formRef.current?.setFieldValue("branchOdPercentage", res?.data?.OD);
      formRef.current?.setFieldValue("branchTpPercentage", res?.data?.TP);
      formRef.current?.setFieldValue("branchNetPercentage", res?.data?.Net);
    });
    GetReceivablePayablePercentage(selectedData?._id).then((res) => {
      formRef.current?.setFieldValue("receivableOdPercentage", res?.data?.OD);
      formRef.current?.setFieldValue("receivableTpPercentage", res?.data?.TP);
      formRef.current?.setFieldValue("receivableNetPercentage", res?.data?.Net);
    });
  };

  const AutoFillFunction = () => {
    if (!selectedData?._id) {
      ToastError("Policy ID not found.");
      return;
    }

    setOpenLoader(true);
    retreiveDataFromPolicy(selectedData._id)
      .then((res) => {
        setOpenLoader(false);

        // Check if response has error (could be at top level or nested in data)
        if (res?.error === true || res?.data?.error === true) {
          const errorMessage = res?.message || res?.data?.message || "Failed to retrieve policy data.";
          ToastError(errorMessage);
          return;
        }

        // Check if response data exists
        if (!res?.data) {
          ToastError("No policy data found.");
          return;
        }

        // Additional check: if data itself is an error object
        if (typeof res.data === 'object' && res.data.error === true) {
          ToastError(res.data.message || "Failed to retrieve policy data.");
          return;
        }

        // formRef.setFieldValue(
        //   "fuelType",
        //   res?.data?.vehicle_details?.fuelType.toUpperCase() || ""
        // );
        formRef.current?.setFieldValue(
          "customerName",
          res?.data?.customer_details?.name || ""
        );
        formRef.current?.setFieldValue(
          "email",
          res?.data?.customer_details?.email || ""
        );
        formRef.current?.setFieldValue(
          "mobileNumber",
          res?.data?.customer_details?.mobile || ""
        );
        formRef.current?.setFieldValue(
          "make",
          res?.data?.vehicle_details?.make || ""
        );
        formRef.current?.setFieldValue("model", res?.data?.vehicle_details?.model || "");
        formRef.current?.setFieldValue(
          "seatingCapacity",
          res?.data?.vehicle_details?.seating_capacity || ""
        );
        formRef.current?.setFieldValue(
          "registrationYear",
          res?.data?.vehicle_details?.registered_year || ""
        );
        formRef.current?.setFieldValue(
          "registrationNumber",
          res?.data?.vehicle_details?.registration_number || ""
        );
        formRef.current?.setFieldValue("cc", res?.data?.vehicle_details?.cc || "");
        formRef.current?.setFieldValue("gvw", res?.data?.vehicle_details?.gvw || "");
        formRef.current?.setFieldValue(
          "odPremium",
          String(res?.data?.premium?.od)?.replace(/,/g, "")
        );
        formRef.current?.setFieldValue(
          "tpPremium",
          String(res?.data?.premium?.tp)?.replace(/,/g, "")
        );
        formRef.current?.setFieldValue(
          "netPremium",
          String(res?.data?.premium?.net)?.replace(/,/g, "")
        );
        // formRef.setFieldValue(
        //   "paCover",
        //   String(res?.data?.premium?.pacover)?.replace(/,/g, "")
        // );

        // const ResCompany = res.data.companyName ? res.data.companyName : "";
        // const foundCompany = companyDetails.find(
        //   (company) => company.companyName === ResCompany.toUpperCase()
        // );
        // if (res?.data?.issueDate) {
        //   const dateStr = res.data.issueDate;
        //   const daysjsDate = dayjs(dateStr, "DD/MM/YYYY");
        //   formRef.setFieldValue("issueDate", daysjsDate.$d);
        //   setFillIssueDate(daysjsDate);
        // }
        const OD_StartDate = res?.data?.coverage?.od_policy?.start_date || "";
        if (OD_StartDate) {
          const daysjsDate = dayjs(OD_StartDate, "DD/MM/YYYY");
          formRef.current?.setFieldValue("odPolicyStartDate", daysjsDate.$d);
          setOdPolicyStartDate(daysjsDate.$d);
        }
        const OD_EndDate = res?.data?.coverage?.od_policy?.end_date || "";
        if (OD_EndDate) {
          const daysjsDate = dayjs(OD_EndDate, "DD/MM/YYYY");
          formRef.current?.setFieldValue("odPolicyEndDate", daysjsDate.$d);
          setOdPolicyEndDateValue(daysjsDate.$d);
        }
        const TP_StartDate = res?.data?.coverage?.tp_policy?.start_date || "";
        if (TP_StartDate) {
          const daysjsDate = dayjs(TP_StartDate, "DD/MM/YYYY");
          formRef.current?.setFieldValue("tpPolicyStartDate", daysjsDate.$d);
          setTpPolicyStartDate(daysjsDate.$d);
        }

        const TP_EndDate = res?.data?.coverage?.tp_policy?.end_date || "";
        if (TP_EndDate) {
          const daysjsDate = dayjs(TP_EndDate, "DD/MM/YYYY");
          formRef.current?.setFieldValue("tpPolicyEndDate", daysjsDate.$d);
          settpPolicyDate(daysjsDate.$d);
        }

        const odPolicyPeriod = res?.data?.coverage?.od_policy?.period || "";
        formRef.current?.setFieldValue("odPolicyPeriod", odPolicyPeriod);

        const tpPolicyPeriod = res?.data?.coverage?.tp_policy?.period || "";
        formRef.current?.setFieldValue("tpPolicyPeriod", tpPolicyPeriod);

        // Show success message only if we have valid data
        // Check if we have at least some customer or vehicle data
        const hasValidData =
          res?.data?.customer_details ||
          res?.data?.vehicle_details ||
          res?.data?.premium ||
          res?.data?.coverage;

        if (hasValidData) {
          ToastSuccess("Policy data auto-filled successfully.");
        } else {
          ToastError("No valid policy data found to auto-fill.");
        }

        // if (foundCompany) {
        //   formRef.setFieldValue("companyId", foundCompany?.value);
        //   setSelectedCompany(foundCompany?.companyName);
        // } else {
        //   formRef.setFieldValue("companyId", null);
        //   setSelectedCompany("");
        //   // ToastError(
        //   //   `" ${ResCompany.toUpperCase()} "  Not added yet, Please add that Company !`
        //   // );
        // }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.error("Error in AutoFillFunction:", error);
        ToastError("Failed to retrieve policy data. Please try again.");
      });
  };
  const policyNumberChecking = (data) => {
    if (
      selectedData.policyNumber.toLowerCase() ===
      data.checkedNumber.toLowerCase()
    ) {
      setShowPolUpTable(true);
      setShowRejectField(false);
      setApproveKey("key_01");
    } else {
      ToastError("Policy Number Missmatching");
      setShowRejectField(true);
      setShowPolUpTable(false);
      setApproveKey(null);
    }
  };
  const RejectedFunction = (data) => {
    data.status = PolicyFilterTypes[6].value;
    data.rejectedReason = data?.rejectedReason;
    UpdatePolicyList(selectedData?._id, data).then((res) => {
      GetData();
      setOpenEditPolicyDrawer(false);
      ToastError("Rejected Succesfully");
    });
  };

  const ViewPdfFunction = () => {
    // Prevent multiple simultaneous calls
    if (openLoader) {
      return;
    }

    if (!selectedData?._id) {
      ToastError("Policy ID not found.");
      return;
    }

    setOpenLoader(true);
    GetPolicyFileById(selectedData._id)
      .then((res) => {
        // Check if response has error
        if (res?.error) {
          setOpenLoader(false);
          ToastError(res?.message || "Failed to fetch PDF file.");
          return;
        }

        // Check if response data exists
        if (!res?.data) {
          setOpenLoader(false);
          ToastError("PDF file data not found.");
          return;
        }

        const pdfUrl = res.data?.policyFile?.downloadURL;

        if (!pdfUrl) {
          setOpenLoader(false);
          ToastError("PDF file URL not found.");
          return;
        }

        setOpenLoader(false);

        // Check if pdfUrl is already a URL (signed URL from S3) or base64 string
        const isUrl = typeof pdfUrl === "string" && (pdfUrl.startsWith("http://") || pdfUrl.startsWith("https://"));

        if (isUrl) {
          // If it's already a URL, use it directly
          const pdfWindow = window.open("", "_blank");
          if (pdfWindow) {
            pdfWindow.document.write(
              `<embed src="${pdfUrl}" width="100%" height="100%" />`
            );
          }
        } else {
          // If it's base64, convert to blob
          try {
            const blobData = base64toBlob(pdfUrl, "application/pdf");
            const blobUrl = URL.createObjectURL(blobData);
            const pdfWindow = window.open("", "_blank");
            if (pdfWindow) {
              pdfWindow.document.write(
                `<embed src="${blobUrl}" width="100%" height="100%" />`
              );
            }
          } catch (error) {
            console.error("Error converting base64 to blob:", error);
            ToastError("Failed to display PDF. Invalid file format.");
          }
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.error("Error fetching PDF:", error);
        ToastError("Failed to fetch PDF file. Please try again.");
      });
  };

  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const ViewXlFunction = () => {
    if (!selectedData?.BulkUploadExecelFile) {
      ToastError("No bulk upload Excel file found for this policy.");
      return;
    }

    setOpenLoader(true);
    GetBulkUploadExcelFileById(selectedData.BulkUploadExecelFile)
      .then((res) => {
        if (res?.error) {
          setOpenLoader(false);
          ToastError(res?.message || "Failed to fetch Excel file details.");
          return;
        }

        const fileKey = res?.data?.file?.key;
        const fileName = res?.data?.file?.fileName || "bulk_upload_file.xlsx";
        if (!fileKey) {
          setOpenLoader(false);
          ToastError("Excel file key not found.");
          return;
        }

        return downloadFileByKey(fileKey).then((downloadRes) => ({
          downloadRes,
          fileName,
        }));
      })
      .then((result) => {
        if (!result || !result.downloadRes) {
          setOpenLoader(false);
          return;
        }

        const downloadURL = result.downloadRes?.data?.downloadURL;
        if (!downloadURL) {
          setOpenLoader(false);
          ToastError("Failed to get Excel file download URL.");
          return;
        }

        // Download the Excel file
        setOpenLoader(false);
        const link = document.createElement("a");
        link.href = downloadURL;
        link.download = result.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        setOpenLoader(false);
        console.error("Error downloading Excel file:", error);
        ToastError("Failed to download Excel file. Please try again.");
      });
  };


  const [odPolicyStartDate, setOdPolicyStartDate] = useState(
    formType === "edit"
      ? dayjs(selectedData?.odPolicyStartDate)
      : dayjs(TodayDate)
  );
  const OdPolicyStDateFunction = (e) => {
    setOdPolicyStartDate(e.$d);
    setTpPolicyStartDate(e.$d);
    formRef.current?.setFieldValue("odPolicyStartDate", e.$d);
    formRef.current?.setFieldValue("tpPolicyStartDate", e.$d);
  };

  const OdPolicyPeriodFunction = (event) => {
    formRef.current?.setFieldValue("odPolicyPeriod", event.target.value);
    const odPolicyEndDate = moment(odPolicyStartDate)
      .add(event.target.value, "Y")
      .subtract(1, "days");
    formRef.current?.setFieldValue("odPolicyEndDate", odPolicyEndDate?._d);
    setOdPolicyEndDateValue(odPolicyEndDate);
  };

  const [tpPolicyStartDate, setTpPolicyStartDate] = useState(
    formType === "edit"
      ? dayjs(selectedData?.tpPolicyStartDate)
      : dayjs(TodayDate)
  );

  const TPPolicyStDateFunction = (e) => {
    setTpPolicyStartDate(e.$d);
    formRef.current?.setFieldValue("tpPolicyStartDate", e.$d);
  };

  const TpPolicyPeriodFunction = (event) => {
    formRef.current?.setFieldValue("tpPolicyPeriod", event.target.value);
    const tpPolicyEndDate = moment(tpPolicyStartDate)
      .add(event.target.value, "Y")
      .subtract(1, "days");
    formRef.current?.setFieldValue("tpPolicyEndDate", tpPolicyEndDate?._d);
    settpPolicyDate(tpPolicyEndDate);
  };

  const EditableFunction = () => {
    setEditableData(false);
    setOpenViewCal(false); // Changes by Arun
  };

  const ErrorHandling = async (errors) => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
      const firstError = errors[errorKeys[0]];
      await ToastError(firstError);
    }
  };
  const shouldShowTabs = () => {
    // Show tabs for EditIcon, CommonEdit and EntryPendingButton
    return editType === "EditIcon" || editType === "CommonEdit" || editType === "EntryPendingButton";
  };

  // Update the condition to show policy number check


  const shouldShowPolicyCheck = () => {

    // Original logic for other cases
    return !(
      selectedData?.status === PolicyFilterTypes[1].value ||
      selectedData?.status === PolicyFilterTypes[2].value
    ) || editType === "CommonEdit";
  };

  return (
    <>
      <CancelPolicyDialog
        open={openCancelPolicyDialog}
        onClose={() => setOpenCancelPolicyDialog(false)}
        policy={selectedData}
        onCancelled={() => {
          if (GetData) GetData();
          setOpenEditPolicyDrawer(false);
        }}
      />
      <div className={Styles.MainRenderinContainer}>
        {/* <Grid container className="DrawerHeader">
          <Grid item xs={6} sm={6}>
            <Typography>
              {formType === "view" ? "View Policy List" : "Edit Policy List"}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => setOpenEditPolicyDrawer(false)}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid> */}

        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <a
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Home"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a
              className="text-color"
              onClick={() => {
                setOpenEditPolicyDrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"Policy List"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a className="text-color">{"Edit Policy List"}</a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
        </Stack>

        {formType === "view" ? (
          <div className={Styles.formContainer}>
            <Grid
              container
              className="Master_Card_Container"
              sx={{ border: "none" }}
            >
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography className="Master_Card_Tittle">
                    {/* {source == "Profile" ? source : "Add User"} */}
                    View Policy List
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  className="d-flex justify-content-end"
                >
                  <CloseIcon
                    onClick={() => setOpenEditPolicyDrawer(false)}
                    sx={{ cursor: "pointer" }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
            </Grid>

            <Box className={Styles.formContent}>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Policy Files
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Create Policy
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.createdBy}
                        <br />
                        {selectedData?.createdAt
                          ? moment(selectedData?.createdAt).format(
                            "DD/MM/YYYY hh:mm:ss A"
                          )
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Entry Pending
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.verifyPendingBy || "--"}
                        <br />
                        {selectedData?.verifyPendingAt
                          ? moment(selectedData?.verifyPendingAt).format(
                            "DD/MM/YYYY hh:mm:ss A"
                          )
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Approved
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.approveBy || "--"}
                        <br />
                        {selectedData?.userPayable?.updatedAt
                          ? moment(selectedData?.userPayable?.updatedAt).format(
                            "DD/MM/YYYY hh:mm:ss A"
                          )
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        CC Entry
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.ticketCreatedBy || "--"}
                        <br />
                        {selectedData?.ticketCreatedDate
                          ? moment(selectedData?.ticketCreatedDate).format(
                            "DD/MM/YYYY hh:mm:ss A"
                          )
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm="auto">
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        View PDF
                      </Typography>
                      <Typography
                        className={Styles.inputValue}
                        sx={{ cursor: "pointer" }}
                        onClick={() => ViewPdfFunction()}
                      >
                        <RemoveRedEyeIcon />
                      </Typography>
                    </Grid>
                    {/* {selectedData?.BulkUploadExecelFile && (
                      <Grid item xs={6} sm="auto">
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Download XL
                        </Typography>
                        <Typography
                          className={Styles.inputValue}
                          sx={{ cursor: "pointer" }}
                          onClick={() => ViewXlFunction()}
                        >
                          <FileDownloadIcon />
                        </Typography>
                      </Grid>
                    )} */}
                    <Grid item xs={6} sm="auto">
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1, cursor: "pointer" }}
                      >
                        Other Documents
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        <DescriptionSharpIcon />
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        User Name
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.userId?.name || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Branch
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {/* {selectedData?.userId?.name} */}--
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Policy Details
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Issue Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.issueDate).format("L")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Company Name
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.companyId?.companyName || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Product
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.productId?.product || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Sub Product
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.subProductId?.subProduct || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Booking Code
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.bookingCodeId?.bookingCode || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Sub Booking Code
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.subBookingCodeId?.subBookingCode || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Policy Type
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.policyTypeId?.policyType || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Policy Number
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.policyNumber || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        LoginId
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.loginIdFull || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>

              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Customer Details
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Customer Name
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.customerName || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Mobile
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.mobileNumber || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Email
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.email || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>

              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Vehicle Details
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Reg Number
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.registrationNumber || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Make
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.make?.vehicleMake || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Model
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.model || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        CC
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.cc || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Seating Capacity
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.seatingCapacity || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        GVW
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.gvw || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  OD Policy Date
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Policy Start Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.odPolicyStartDate).format("L")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Policy Period
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.odPolicyPeriod || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Policy End Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.odPolicyEndDate).format("L")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  TP Policy Date
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        TP Policy Start Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.tpPolicyStartDate).format("L")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        TP Policy Period
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.tpPolicyPeriod || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        TP Policy End Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.tpPolicyEndDate).format("L")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>

              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Premium
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Disc
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.odDisc ? Math.round(selectedData?.odDisc) : "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Premium
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.odPremium ? Math.round(selectedData?.odPremium) : "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        TP Premium
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.tpPremium ? Math.round(selectedData?.tpPremium) : "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        NET Premium
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.netPremium ? Math.round(selectedData?.netPremium) : "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Total Premium
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.totalPremium ? Math.round(selectedData?.totalPremium) : "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        PA Cover
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.paCover || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Payment Details
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Payment Mode
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.paymentMode || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                  </Grid>
                </Stack>
              </Box>
            </Box>
          </div>
        ) : (
          <div className={Styles.formContainer}>
            <Grid
              container
              className="Master_Card_Container"
              sx={{ border: "none" }}
            >
              <Grid item xs={12}>
                <Formik
                  initialValues={initialValues}
                  onSubmit={(values) => {
                    onSubmit(values);
                  }}
                  innerRef={(ref) => {
                    if (ref) {
                      if (value === 1) {
                        setDisableOne(
                          ref?.errors?.bookingCodeId?.length ||
                            ref?.errors?.policyTypeId?.length ||
                            ref?.errors?.companyId?.length ||
                            ref?.errors?.productId?.length ||
                            ref?.errors?.subBookingCodeId?.length ||
                            ref?.errors?.subProductId?.length
                            ? true
                            : false
                        );
                      } else if (value === 2) {
                        setDisableOne(
                          ref?.errors?.customerName?.length ||
                          ref?.errors?.mobileNumber?.length ||
                          ref?.errors?.email?.length
                        );
                      } else if (value === 3) {
                        setDisableOne(
                          ref?.errors?.registrationNumber?.length ||
                          ref?.errors?.make?.length ||
                          ref?.errors?.model?.length ||
                          ref?.errors?.cc?.length ||
                          ref?.errors?.gvw?.length ||
                          ref?.errors?.seatingCapacity?.length ||
                          ref?.errors?.registrationYear?.length ||
                          ref?.errors?.fuelType?.length ||
                          ref?.errors?.addOnId?.length
                        );
                      } else if (value === 4) {
                        setDisableOne(
                          ref?.errors?.odPolicyStartDate?.length ||
                          ref?.errors?.odPolicyPeriod?.length ||
                          ref?.errors?.odPolicyEndDate?.length ||
                          ref?.errors?.tpPolicyEndDate?.length ||
                          ref?.errors?.odPolicyPeriod?.length ||
                          ref?.errors?.tpPolicyPeriod?.length
                        );
                      } else if (value === 5) {
                        setDisableOne(
                          ref?.errors?.odDisc?.length ||
                          ref?.errors?.odPremium?.length ||
                          ref?.errors?.tpPremium?.length ||
                          ref?.errors?.netPremium?.length ||
                          ref?.errors?.totalPremium?.length ||
                          ref?.errors?.paCover?.length
                        );
                      }
                      formRef.current = ref;
                    }
                  }}
                  validationSchema={
                    editType === "CommonEdit" ? null : validationSchema
                  }
                >
                  {({ values, setFieldValue, errors }) => (
                    <Form className={Styles.formContent} sx={{ width: "100%" }}>
                      <Grid
                        container
                        alignItems={"center"}
                        className="Master_Card_Sub_Container"
                      >
                        <Grid item xs={12} sm={6} md={6}>
                          <Typography className="Master_Card_Tittle">
                            {/* {source == "Profile" ? source : "Add User"} */}
                            Edit Policy List
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          className="d-flex justify-content-end"
                        >
                          {selectedData?.status === "approvedPolicy" &&
                            sessionStorage.getItem("userType") === "CLIENT" && (
                              <Button
                                onClick={() => setOpenCancelPolicyDialog(true)}
                                className={Styles.cancel_policy_btn}
                                sx={{ marginRight: "8px" }}
                              >
                                Cancel Policy
                              </Button>
                            )}
                          <CloseIcon
                            onClick={() => setOpenEditPolicyDrawer(false)}
                            sx={{ cursor: "pointer" }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider
                          sx={{
                            backgroundColor: "#EAECF0",
                            borderWidth: 1,
                          }}
                        />
                      </Grid>
                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          padding: "0 15px",
                          paddingBottom: "20px",
                        }}
                      >
                        <Typography mt={3} className={Styles.formTitleHead}>
                          Policy Files
                        </Typography>

                        <Stack direction={"row"}>
                          <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Create Policy
                              </Typography>
                              <Typography className={Styles.inputValue}>
                                {selectedData?.createdBy}
                                <br />
                                {selectedData?.createdAt
                                  ? moment(selectedData?.createdAt).format(
                                    "DD/MM/YYYY hh:mm:ss A"
                                  )
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Entry Pending
                              </Typography>
                              <Typography className={Styles.inputValue}>
                                {selectedData?.verifyPendingBy || "--"}
                                <br />
                                {selectedData?.verifyPendingAt
                                  ? moment(
                                    selectedData?.verifyPendingAt
                                  ).format("DD/MM/YYYY hh:mm:ss A")
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Approved
                              </Typography>
                              <Typography className={Styles.inputValue}>
                                {selectedData?.approveBy || "--"}
                                <br />
                                {selectedData?.userPayable?.updatedAt
                                  ? moment(
                                    selectedData?.userPayable?.updatedAt
                                  ).format("DD/MM/YYYY hh:mm:ss A")
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                CC Entry
                              </Typography>
                              <Typography className={Styles.inputValue}>
                                {selectedData?.ticketCreatedBy || "--"}
                                <br />
                                {selectedData?.ticketCreatedDate
                                  ? moment(
                                    selectedData?.ticketCreatedDate
                                  ).format("DD/MM/YYYY hh:mm:ss A")
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                View PDF
                              </Typography>
                              <Typography
                                className={Styles.inputValue}
                                sx={{ cursor: "pointer" }}
                                onClick={() => ViewPdfFunction()}
                              >
                                <RemoveRedEyeIcon />
                              </Typography>
                            </Grid>
                            {/* {selectedData?.BulkUploadExecelFile && (
                              <Grid item xs={12} sm={2}>
                                <Typography
                                  className={Styles.inputTitle}
                                  sx={{ fontSize: "12px", mb: 1 }}
                                >
                                  Download XL
                                </Typography>
                                <Typography
                                  className={Styles.inputValue}
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => ViewXlFunction()}
                                >
                                  <FileDownloadIcon />
                                </Typography>
                              </Grid>
                            )} */}
                            <Grid
                              item
                              xs={12}
                              sm={2}
                              sx={{ display: approveKey ? "block" : "none" }}
                            >
                              <Typography
                                className={Styles.inputTitle}
                                sx={{
                                  fontSize: "12px",
                                  mb: 1,
                                  cursor: "pointer",
                                }}
                              >
                                Auto Fill
                              </Typography>
                              <Typography
                                className={Styles.inputValue}
                                onClick={() => AutoFillFunction()}
                              >
                                <DescriptionSharpIcon />
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={2}
                              sx={{
                                display:
                                  selectedData?.status ===
                                    PolicyFilterTypes[1].value
                                    ? "none"
                                    : "block",
                              }}
                            >
                              <Typography
                                className={Styles.inputTitle}
                                sx={{
                                  fontSize: "12px",
                                  mb: 1,
                                  cursor: "pointer",
                                }}
                              >
                                Other Documents
                              </Typography>
                              <Typography
                                className={Styles.inputValue}
                                sx={{
                                  display:
                                    selectedData?.status ===
                                      PolicyFilterTypes[1].value
                                      ? "none"
                                      : "block",
                                }}
                              >
                                <DescriptionSharpIcon />
                              </Typography>
                            </Grid>
                            {showPolUpTable ||
                              selectedData?.status ===
                              PolicyFilterTypes[2].value ||
                              editType === "EntryPending" ? null : (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sm={3}
                                  sx={{
                                    display:
                                      !PolicyFilterTypes[1].value ||
                                        editType === "CommonEdit"
                                        ? "none"
                                        : "block",
                                  }}
                                >
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Policy Number
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    placeHolder="Enter Policy Number"
                                    name="checkedNumber"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={1} />
                                <Grid
                                  item
                                  xs={12}
                                  sm={3}
                                  sx={{
                                    display:
                                      !PolicyFilterTypes[2].value ||
                                        editType === "CommonEdit"
                                        ? "none"
                                        : "block",
                                  }}
                                >
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  ></Typography>
                                  <Button
                                    className="Master_Card_create_Button"
                                    sx={{ marginTop: "18px" }}
                                    onClick={() => policyNumberChecking(values)}
                                  >
                                    Check
                                  </Button>
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Stack>
                      </Box>

                      {/* {showRejectField ? () */}
                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          padding: "0 15px",
                          display: showRejectField ? "block" : "none",
                          paddingBottom: "20px",
                        }}
                      >
                        <Typography mt={3} className={Styles.formTitleHead}>
                          Rejected
                        </Typography>

                        <Stack direction={"row"} sx={{ width: "100%" }}>
                          <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} sm={3} sx={{ mb: 2 }}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Reason
                              </Typography>
                              <Autocomplete
                                className="AutoComplete_InputBox"
                                options={[
                                  {
                                    label: "Policy Number Mismatching",
                                    id: 1,
                                  },
                                  { label: "Other Agent Policy", id: 2 },
                                ]}
                                onChange={(e, v) =>
                                  setFieldValue("rejectedReason", v.label)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select Reason"
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={1}></Grid>
                            <Grid item xs={12} sm={3} sx={{ mb: 1 }}>
                              <Button
                                onClick={() => RejectedFunction(values)}
                                className={Styles.Reject_Button}
                              >
                                Reject
                              </Button>
                            </Grid>
                          </Grid>
                        </Stack>
                      </Box>

                      {editType !== "EntryPendingButton" ||
                        editType === "CommonEdit" ? (
                        <Box sx={{ width: "100%", typography: "body1" }}>
                          <TabContext value={value}>
                            <Box
                              sx={{
                                // borderBottom: 1,
                                // borderColor: "divider",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="stepper tabs"
                                sx={{
                                  borderBottom: "none",
                                  ".MuiTabs-indicator": { display: "none" }, // Hide the bottom indicator line
                                  backgroundColor: "none",
                                }}
                              >
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${value === 1 ? Styles.active : ""
                                        }`}
                                    >
                                      <span className={Styles.circle}>1</span>{" "}
                                      Policy Details
                                    </span>
                                  }
                                  value={1}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${value === 2 ? Styles.active : ""
                                        }`}
                                    >
                                      <span className={Styles.circle}>2</span>{" "}
                                      Customer Details
                                    </span>
                                  }
                                  value={2}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${value === 3 ? Styles.active : ""
                                        }`}
                                    >
                                      <span className={Styles.circle}>3</span>{" "}
                                      Vehicle Details
                                    </span>
                                  }
                                  value={3}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>{" "}
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${value === 4 ? Styles.active : ""
                                        }`}
                                    >
                                      <span className={Styles.circle}>4</span>{" "}
                                      Policy Date
                                    </span>
                                  }
                                  value={4}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>{" "}
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${value === 5 ? Styles.active : ""
                                        }`}
                                    >
                                      <span className={Styles.circle}>5</span>{" "}
                                      Premium
                                    </span>
                                  }
                                  value={5}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>{" "}
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${value === 6 ? Styles.active : ""
                                        }`}
                                    >
                                      <span className={Styles.circle}>6</span>{" "}
                                      Payment Details
                                    </span>
                                  }
                                  value={6}
                                />
                              </Tabs>
                            </Box>
                            <TabPanel value={1}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    User Name
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="userId"
                                    options={userDetails}
                                    value={userValue}
                                    disabled={editableData}
                                    onInputChange={(e, v) => setUserValue(v)}
                                    onChange={(e, v) => {
                                      setFieldValue("userId", v?._id);
                                      setSelectedUserId(v?._id);
                                      setUserValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select User"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.label === value
                                    }
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.name}
                                      </li>
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Login ID
                                  </Typography>
                                  <Autocomplete
                                    name="loginIdFull"
                                    disablePortal
                                    className="AutoComplete_InputBox"
                                    id="combo-box-demo"
                                    value={selectedLoginPortal}
                                    options={loginPortalDetails}
                                    disabled={editableData}
                                    onChange={(e, v) => {
                                      setSelectedLoginPortal(v?.loginPortal);
                                      // setFieldValue("loginId.companyId", v?.companyId)
                                      // setFieldValue("loginId.userId", v?.userId)
                                      setFieldValue(
                                        "loginIdFull",
                                        v?.loginPortal
                                      );
                                    }}
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.loginPortal}
                                      </li>
                                    )}
                                    getOptionLabel={(option) => {
                                      // console.log("option  ", option);
                                      return typeof option === "object" &&
                                        option !== null
                                        ? option.loginPortal || "Unknown"
                                        : option;
                                    }}
                                    isOptionEqualToValue={(e, v) =>
                                      e.loginPortal === v
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Login ID"
                                      />
                                    )}
                                  />
                                </Grid>

                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Policy Number
                                  </Typography>
                                  <Field
                                    name="policyNumber"
                                    placeHolder="Enter Policy Number"
                                    className="textField w-100"
                                    disabled={editableData}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Issue Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="issueDate"
                                      className="Date_Picker w-100"
                                      value={fillIssueDate}
                                      disabled={editableData}
                                      onChange={(e) =>
                                        setFieldValue("issueDate", e.$d)
                                      }
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Company
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="companyId"
                                    options={companyDetails}
                                    value={selectedCompany}
                                    disabled={editableData}
                                    onChange={(e, v) => {
                                      setFieldValue("companyId", v?._id);
                                      setSelectedCompanyId(v?._id);
                                      setCompanyValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Company"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.label === value
                                    }
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.shortName}
                                      </li>
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Booking Code
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="bookingCodeId"
                                    options={bookingCodeDetails}
                                    value={bookingCodeValue}
                                    disabled={editableData}
                                    onInputChange={(e, v) =>
                                      setBookingCodeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue(
                                        "bookingCodeId",
                                        v?.bookingCodeId._id
                                      );
                                      setBookingCodeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Booking Code"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.bookingCode === value
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Sub Booking Code
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="subBookingCodeId"
                                    options={subBookingCodeDetails}
                                    value={subBookingCodeValue}
                                    disabled={editableData}
                                    onInputChange={(e, v) =>
                                      setSubBookingCodeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("subBookingCodeId", v?._id);
                                      setSubBookingCodeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Sub Booking"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.subBookingCode === value
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Product
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="productId"
                                    options={productDetails}
                                    value={productValue}
                                    disabled={editableData}
                                    onInputChange={(e, v) => setProductValue(v)}
                                    onChange={(e, v) => {
                                      setFieldValue("productId", v?._id);
                                      setProductIdValue(v?._id);
                                      setProductValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Product"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.product === value
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Sub Product
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="subProductId"
                                    options={subProductDetails}
                                    value={subProductValue}
                                    disabled={editableData}
                                    onInputChange={(e, v) =>
                                      setSubProductValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("subProductId", v?._id);
                                      setSubProductIdValue(v?._id);
                                      setSubProductValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Sub Product"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.subProduct === value
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Policy Type
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="policyTypeId"
                                    options={policyTypeDetails}
                                    value={policyTypeValue}
                                    disabled={editableData}
                                    onInputChange={(e, v) =>
                                      setPolicyTypeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("policyTypeId", v?._id);
                                      setPolicyTypeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Policy Type"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.policyType === value
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setValue(1)}
                                    sx={{
                                      borderColor: '#1976d2',
                                      color: '#1976d2',
                                      '&:hover': { borderColor: '#1565c0', backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3,
                                      backgroundColor: '#1976d2',
                                      color: '#fff',
                                    }}
                                  >
                                    Back
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={() => setValue(2)}
                                    sx={{
                                      backgroundColor: '#1976d2',
                                      '&:hover': { backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3
                                    }}
                                  >
                                    Next
                                  </Button>
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={2}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Customer Name
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="customerName"
                                    placeHolder="Enter Customer Name"
                                    disabled={editableData}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Mobile Number
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="mobileNumber"
                                    placeHolder="Enter Mobile Number"
                                    disabled={editableData}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Email
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="email"
                                    placeHolder="Enter Email"
                                    disabled={editableData}
                                  />
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setValue(1)}
                                    sx={{
                                      borderColor: '#1976d2',

                                      '&:hover': { borderColor: '#1565c0', backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3,
                                      backgroundColor: '#1976d2',
                                      color: '#fff',
                                    }}
                                  >
                                    Back
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={() => setValue(3)}
                                    sx={{
                                      backgroundColor: '#1976d2',
                                      '&:hover': { backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3
                                    }}
                                  >
                                    Next
                                  </Button>
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={3}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={1.75}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Registration Number
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="registrationNumber"
                                    placeHolder="Enter Registration Number"
                                    disabled={editableData}
                                    onBlur={
                                      (e) => checkRTO(rtoList, e.target.value) // Changes by Arun
                                    }
                                  />
                                </Grid>
                                {/* Changes by Arun */}
                                <Grid item xs={12} sm={1.75}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    RTO
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="rtoId"
                                    options={rtoListDropdown}
                                    value={rtoValue}
                                    onChange={(e, v) => {
                                      setFieldValue("rtoId", v?._id);
                                      setRtoValue(v?.label);
                                    }}
                                    // changes by somesh
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.label}
                                      </li>
                                    )}
                                    clearIcon={true}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select RTO"
                                      />
                                    )}
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Make{" "}
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="make"
                                    options={vehicleMakeDetails}
                                    value={vehicleValue}
                                    onChange={(e, v) => {
                                      setFieldValue("make", v?._id);
                                      setVehicleValue(v?.label);
                                    }}
                                    clearIcon={false}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Make"
                                      />
                                    )}
                                    isOptionalEqualToValue={(option, value) =>
                                      option.vehicleMake === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Model
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="model"
                                    placeHolder="Enter Model"
                                    disabled={editableData}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Grid container spacing={1}>
                                    <Grid item sx={{ width: "30%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        CC
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="cc"
                                        placeHolder="Enter CC"
                                        disabled={editableData}
                                      />
                                    </Grid>
                                    <Grid item sx={{ width: "30%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        GVW
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="gvw"
                                        placeHolder="Enter GVW"
                                        disabled={editableData}
                                      />
                                    </Grid>
                                    <Grid item sx={{ width: "40%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        Seating Capacity
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="seatingCapacity"
                                        placeHolder="Enter Seating Capacity"
                                        disabled={editableData}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Registration Year
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="registrationYear"
                                    placeHolder="Enter Registration Year"
                                    disabled={editableData}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Fuel Type
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="fuelType"
                                    options={fuelType}
                                    value={fuelTypeValue}
                                    onInputChange={(e, v) =>
                                      setFuelTypeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("fuelType", v?._id);
                                      setFuelTypeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Fuel Type"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.fuelType === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Add-ons
                                  </Typography>
                                  <Autocomplete
                                    multiple
                                    className="AutoComplete_InputBox"
                                    name="addOnId"
                                    options={addOnDetails}
                                    value={addOnDetails.filter((addon) =>
                                      selectedAddOns.includes(addon._id)
                                    )}
                                    onChange={(e, v) => {
                                      const selectedIds = v.map((item) => item._id);
                                      setSelectedAddOns(selectedIds);
                                      setFieldValue("addOnId", selectedIds);
                                    }}
                                    getOptionLabel={(option) => option.label || ""}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Add-ons"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option._id === value._id
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setValue(2)}
                                    sx={{
                                      borderColor: '#1976d2',
                                      color: '#fff',
                                      backgroundColor: '#1976d2',
                                      '&:hover': { borderColor: '#1565c0', backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3
                                    }}
                                  >
                                    Back
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={() => setValue(4)}
                                    sx={{
                                      backgroundColor: '#1976d2',
                                      '&:hover': { backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3
                                    }}
                                  >
                                    Next
                                  </Button>
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={4}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy Start Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      name="odPolicyStartDate"
                                      format="DD/MM/YYYY"
                                      className="Date_Picker w-100"
                                      disabled={editableData}
                                      onChange={(e) =>
                                        OdPolicyStDateFunction(e)
                                      }
                                      value={dayjs(odPolicyStartDate)}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy Period
                                  </Typography>
                                  <Select
                                    className="AutoComplete_InputBox w-100"
                                    name="odPolicyPeriod"
                                    value={values?.odPolicyPeriod}
                                    onChange={OdPolicyPeriodFunction}
                                    placeholder="Select Policy Period"
                                    disabled={editableData}
                                  >
                                    {OdPolicyPeriodController.map((e) => (
                                      <MenuItem value={e.value} key={e.value}>
                                        {e.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy End Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="odPolicyEndDate"
                                      className="Date_Picker w-100"
                                      value={dayjs(odPolicyEndDateValue)}
                                      disabled={editableData}
                                      onChange={(e) =>
                                        setFieldValue("odPolicyEndDate", e?.$d)
                                      }
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy Start Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="tpPolicyStartDate"
                                      className="Date_Picker w-100"
                                      disabled={editableData}
                                      onChange={(e) =>
                                        TPPolicyStDateFunction(e)
                                      }
                                      value={dayjs(tpPolicyStartDate)}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy Period
                                  </Typography>
                                  <Select
                                    className="AutoComplete_InputBox w-100"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="tpPolicyPeriod"
                                    value={values?.tpPolicyPeriod}
                                    placeholder="Select Policy Period"
                                    onChange={TpPolicyPeriodFunction}
                                    disabled={editableData}
                                  >
                                    {OdPolicyPeriodController.map((e) => (
                                      <MenuItem value={e.value} key={e.value}>
                                        {e.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy End Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="tpPolicyEndDate"
                                      className="Date_Picker w-100"
                                      value={dayjs(tpPolicyDate)}
                                      disabled={editableData}
                                      onChange={(e) =>
                                        setFieldValue("tpPolicyEndDate", e?.$d)
                                      }
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setValue(3)}
                                    sx={{
                                      borderColor: '#1976d2',
                                      color: '#fff',
                                      backgroundColor: '#1976d2',
                                      '&:hover': { borderColor: '#1565c0', backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3
                                    }}
                                  >
                                    Back
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={() => setValue(5)}
                                    sx={{
                                      backgroundColor: '#1976d2',
                                      '&:hover': { backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3
                                    }}
                                  >
                                    Next
                                  </Button>
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={5}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Disc
                                  </Typography>
                                  <Field name="odDisc">
                                    {({ field, form }) => (
                                      <input
                                        {...field}
                                        type="number"
                                        className="textField w-100"
                                        value={field.value ? Math.floor(field.value) : field.value}
                                        disabled={editableData}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value.includes('.')) {
                                            const intValue = value.split('.')[0];
                                            form.setFieldValue(field.name, intValue);
                                          } else {
                                            form.setFieldValue(field.name, value);
                                          }
                                        }}
                                        onKeyDown={(e) => {
                                          if (['.', ',', 'e', 'E'].includes(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                        placeholder="Enter OD Disc"
                                      />
                                    )}
                                  </Field>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Premium
                                  </Typography>
                                  <Field name="odPremium">
                                    {({ field, form }) => (
                                      <input
                                        {...field}
                                        type="number"
                                        className="textField w-100"
                                        value={field.value ? Math.floor(field.value) : field.value}
                                        disabled={editableData}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value.includes('.')) {
                                            const intValue = value.split('.')[0];
                                            form.setFieldValue(field.name, intValue);
                                          } else {
                                            form.setFieldValue(field.name, value);
                                          }
                                        }}
                                        onKeyDown={(e) => {
                                          if (['.', ',', 'e', 'E'].includes(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                        placeholder="Enter OD Premium"
                                      />
                                    )}
                                  </Field>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Premium
                                  </Typography>
                                  <Field name="tpPremium">
                                    {({ field, form }) => (
                                      <input
                                        {...field}
                                        type="number"
                                        className="textField w-100"
                                        value={field.value ? Math.floor(field.value) : field.value}
                                        disabled={editableData}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value.includes('.')) {
                                            const intValue = value.split('.')[0];
                                            form.setFieldValue(field.name, intValue);
                                          } else {
                                            form.setFieldValue(field.name, value);
                                          }
                                        }}
                                        onKeyDown={(e) => {
                                          if (['.', ',', 'e', 'E'].includes(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                        placeholder="Enter TP Premium"
                                      />
                                    )}
                                  </Field>
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Net Premium
                                  </Typography>
                                  <Field name="netPremium">
                                    {({ field, form }) => (
                                      <input
                                        {...field}
                                        type="number"
                                        className="textField w-100"
                                        // min="0"
                                        // max="9999999999"
                                        // step="1"
                                        value={field.value ? Math.floor(field.value) : field.value}
                                        disabled={editableData}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          // Remove decimals immediately
                                          if (value.includes('.')) {
                                            const intValue = value.split('.')[0];
                                            form.setFieldValue(field.name, intValue);
                                          } else {
                                            form.setFieldValue(field.name, value);
                                          }
                                        }}
                                        onKeyDown={(e) => {
                                          if (['.', ',', 'e', 'E'].includes(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                        placeholder="Enter Net Premium"
                                      />
                                    )}
                                  </Field>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Total Premium
                                  </Typography>
                                  <Field name="totalPremium">
                                    {({ field, form }) => (
                                      <input
                                        {...field}
                                        type="number"
                                        className="textField w-100"
                                        value={field.value ? Math.floor(field.value) : field.value}
                                        disabled={editableData}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value.includes('.')) {
                                            const intValue = value.split('.')[0];
                                            form.setFieldValue(field.name, intValue);
                                          } else {
                                            form.setFieldValue(field.name, value);
                                          }
                                        }}
                                        onKeyDown={(e) => {
                                          if (['.', ',', 'e', 'E'].includes(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                        placeholder="Enter Total Premium"
                                      />
                                    )}
                                  </Field>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    PA Cover
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="paCover"
                                    placeHolder="Enter PA Cover"
                                    disabled={editableData}
                                  />
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                  <Button
                                    variant="outlined"
                                    onClick={() => setValue(4)}
                                    sx={{
                                      borderColor: '#1976d2',
                                      color: '#fff',
                                      backgroundColor: '#1976d2',
                                      '&:hover': { borderColor: '#1565c0', backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3
                                    }}
                                  >
                                    Back
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={() => setValue(6)}
                                    sx={{
                                      backgroundColor: '#1976d2',
                                      '&:hover': { backgroundColor: '#1565c0' },
                                      textTransform: 'none',
                                      px: 3
                                    }}
                                  >
                                    Next
                                  </Button>
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={6}>
                              <Typography
                                sx={{ ml: 2 }}
                                className="EditPageHeadingTittle"
                              >
                                Payment Details
                              </Typography>
                              <Grid container sx={{ p: 2 }} spacing={2}>
                                <Grid item xs={12} sm={4}>
                                  <FloatLabel
                                    label="Payment Mode"
                                    value={values?.paymentMode}
                                    important="*"
                                  >
                                    <Autocomplete
                                      className="AutoComplete_InputBox"
                                      name="paymentMode"
                                      disablePortal
                                      value={values?.paymentMode}
                                      id="combo-box-demo"
                                      options={PaymentDetails}
                                      isOptionEqualToValue={(option, value) =>
                                        option?.label === value
                                      }
                                      onChange={(e, v) => PaymentFunction(v)}
                                      clearIcon={false}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                      disabled={editableData ? true : false}
                                    />
                                  </FloatLabel>
                                </Grid>
                                {showPaymentMethod === 3 ? (
                                  <>
                                    <Grid item xs={12} sm={4}>
                                      <FloatLabel
                                        label="Cheque Number"
                                        value={values?.chequeNumber}
                                        important="*"
                                      >
                                        <Field
                                          name="chequeNumber"
                                          className="textField w-100"
                                          disabled={editableData}
                                        />
                                      </FloatLabel>
                                    </Grid>
                                    <Grid item xs={12} sm={4} className="datePicker">
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                          format="DD/MM/YYYY"
                                          name="chequeDate"
                                          className="Date_Picker w-100"
                                          defaultValue={dayjs()}
                                          disabled={editableData}
                                          onChange={(e) => {
                                            setFieldValue("chequeDate", e.$d);
                                          }}
                                        />
                                      </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                      <FloatLabel
                                        label="Bank Name"
                                        value={values?.bankName}
                                        important="*"
                                      >
                                        <Field
                                          className="textField w-100"
                                          name="bankName"
                                          disabled={editableData}
                                        />
                                      </FloatLabel>
                                    </Grid>
                                  </>
                                ) : null}
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: editableData ? 'center' : 'space-between', mt: 2, gap: 2 }}>
                                  {editableData ? (
                                    <>
                                      <Button
                                        variant="outlined"
                                        onClick={() => EditableFunction()}
                                        sx={{
                                          borderColor: '#1976d2',
                                          color: '#fff',
                                          backgroundColor: '#1976d2',
                                          '&:hover': { borderColor: '#1565c0', backgroundColor: '#1565c0' },
                                          textTransform: 'none',
                                          px: 3
                                        }}
                                      >
                                        Edit Policy
                                      </Button>
                                      <Button
                                        variant="outlined"
                                        onClick={() => GetPayablePercentFunction()}
                                        sx={{
                                          borderColor: '#1976d2',
                                          color: '#fff',
                                          backgroundColor: '#1976d2',
                                          '&:hover': { borderColor: '#1565c0', color: '#1565c0' },
                                          textTransform: 'none',
                                          px: 3
                                        }}
                                      >
                                        {openViewCal ? "Close Calculation" : "View Calculation"}
                                      </Button>
                                      <button
                                        className="w-100 Master_Card_create_Button"
                                        type="submit"
                                        style={{ border: "none", width: "auto" }}
                                        onClick={() => ErrorHandling(errors)}
                                      >
                                        Verify Policy
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <Button
                                        variant="outlined"
                                        onClick={() => setValue(5)}
                                        sx={{
                                          borderColor: '#1976d2',
                                          color: '#fff',
                                          backgroundColor: '#1976d2',
                                          '&:hover': { borderColor: '#1565c0', backgroundColor: '#1565c0' },
                                          textTransform: 'none',
                                          px: 3
                                        }}
                                      >
                                        Back
                                      </Button>
                                      <button
                                        className="w-100 Master_Card_create_Button"
                                        type="submit"
                                        style={{ border: "none", width: "auto" }}
                                        onClick={() => ErrorHandling(errors)}
                                      >
                                        Update
                                      </button>
                                    </>
                                  )}
                                </Grid>
                              </Grid>
                            </TabPanel>
                          </TabContext>

                          <Grid container spacing={1} sx={{ p: 3 }}>
                            {/* <Grid item xs={12} sm={2}>
                            <button className="w-100 TabelButton" onClick={() => setOpenEditPolicyDrawer(false)}>
                              Cancel
                            </button>
                          </Grid> */}
                            {/* <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                display: value === 6 ? "none" : "flex",
                                justifyContent: "end",
                              }}
                            >
                              <Button
                                disabled={disableOne}
                                sx={{ display: disableOne ? "none" : "block" }}
                                className="Common_Button"
                                onClick={(e) => handleChangePerTap(e, value)}
                              >
                                Next
                              </Button>
                            </Grid> */}

                          </Grid>
                        </Box>
                      ) : null}


                      {openViewCal ? (
                        <Grid
                          sx={{ p: 2, transition: "2s" }}
                          className={
                            openViewCal
                              ? "OpenCalculationsBox"
                              : "CloseCalculationsBox"
                          }
                        >
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                              paddingBottom: "20px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              User Approved %
                            </Typography>
                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Percentage
                                  </Typography>
                                  <Field
                                    name="userOdPercentage"
                                    placeHolder="User OD Percentage"
                                    className="textField w-100"
                                    value={values?.userOdPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Percentage
                                  </Typography>
                                  <Field
                                    name="userTpPercentage"
                                    className="textField w-100"
                                    placeHolder="User TP Percentage"
                                    value={values?.userTpPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Percentage
                                  </Typography>

                                  <Field
                                    name="userNetPercentage"
                                    className="textField w-100"
                                    placeHolder="User Net Percentage"
                                    value={values?.userNetPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Amount
                                  </Typography>
                                  <Field
                                    name="userOdAmount"
                                    placeHolder="OD Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Amount
                                  </Typography>
                                  <Field
                                    name="userTpAmount"
                                    placeHolder="TP Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Amount
                                  </Typography>
                                  <Field
                                    name="userNetAmount"
                                    placeHolder="NET Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TOTAL Payable
                                  </Typography>
                                  <Field
                                    name="userTotalPayable"
                                    placeHolder="Total Payable"
                                    className="textField w-100"
                                  />
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                              paddingBottom: "20px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Receivable %
                            </Typography>
                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Percentage
                                  </Typography>
                                  <Field
                                    name="receivableOdPercentage"
                                    className="textField w-100"
                                    placeHolder="Receivable OD Percentage"
                                    value={values?.receivableOdPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Percentage
                                  </Typography>
                                  <Field
                                    name="receivableTpPercentage"
                                    className="textField w-100"
                                    placeHolder="Receivable TP Percentage"
                                    value={values?.receivableTpPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Percentage
                                  </Typography>

                                  <Field
                                    name="receivableNetPercentage"
                                    className="textField w-100"
                                    placeHolder="Receivable NET Percentage"
                                    value={
                                      values?.receivableNetPercentage || ""
                                    } //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Amount
                                  </Typography>
                                  <Field
                                    name="receivableOdAmount"
                                    placeHolder="Receivable OD Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Amount
                                  </Typography>
                                  <Field
                                    name="receivableTpAmount"
                                    placeHolder="Receivable TP Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Amount
                                  </Typography>
                                  <Field
                                    name="receivableNetAmount"
                                    placeHolder="Receivable NET Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TOTAL Payable
                                  </Typography>
                                  <Field
                                    name="receivableTotalPayabl"
                                    placeHolder="Receivable Total Payable"
                                    className="textField w-100"
                                  />
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                              paddingBottom: "20px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Branch %
                            </Typography>
                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Percentage
                                  </Typography>
                                  <Field
                                    name="branchOdPercentage"
                                    placeHolder="Branch OD Percentage"
                                    className="textField w-100"
                                    value={values?.branchOdPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Percentage
                                  </Typography>
                                  <Field
                                    name="branchTpPercentage"
                                    placeHolder="Branch TP Percentage"
                                    className="textField w-100"
                                    value={values?.branchTpPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Percentage
                                  </Typography>

                                  <Field
                                    name="branchNetPercentage"
                                    className="textField w-100"
                                    placeHolder="Branch NET Percentage"
                                    value={values?.branchNetPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Amount
                                  </Typography>
                                  <Field
                                    name="branchOdAmount"
                                    placeHolder="Branch OD Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Amount
                                  </Typography>
                                  <Field
                                    name="branchTpAmount"
                                    placeHolder="Branch TP Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Amount
                                  </Typography>
                                  <Field
                                    name="branchNetAmount"
                                    placeHolder="Branch NET Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TOTAL Payable
                                  </Typography>
                                  <Field
                                    name="branchTotalPayabl"
                                    placeHolder="Branch Total Payable"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Button
                                    endIcon={<CalculateIcon />}
                                    sx={{ marginTop: "30px" }}
                                    className="Master_Card_create_Button"
                                    variant="contained"
                                    onClick={() => CalaculteFunction(values)}
                                  >
                                    Calculate
                                  </Button>
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                        </Grid>
                      ) : null}

                      {/* Update Button - Positioned at the bottom of the form */}
                      <Grid container spacing={1} sx={{ p: 3 }}>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          sx={{
                            display: value === 6 ? "flex" : "none",
                            justifyContent: "end",
                          }}
                        >
                          {/* <button
                            className="w-100 Master_Card_create_Button"
                            type="submit"
                            style={{ border: "none" }}
                            onClick={() => ErrorHandling(errors)}
                          >
                            {editableData ? "Verify Policy" : "Update"}
                          </button> */}
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </div>
        )}
        <Loader open={openLoader} />
      </div>
    </>
  );
};

export default EditPolicyList;

// && data.odDisc && data.odPremium && data.tpPremium && data.netPremium && data.totalPremium
